module.exports = __webpack_public_path__ + "img/bg_02.aeaff479.jpg";